/** @format */

export function getSimilarModelRecommendationsQueryKey(modelIds: number[]) {
    return ['similar-model-recommendations', ...modelIds];
}
